import {
  call,
  select,
  put,
} from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { userSelector } from '../../../../../../selectors';
import Routes from '../../../../../../routes';
import { userAccountCreationStep } from '../userAccountCreationStep';


/**
 *
 * @param {string} flow
 * @param {Object} options
 */
export function* schoolCoachSignupFlow(flow = 'school-coach', options) {
  yield call(userAccountCreationStep, flow, options);
  const user = yield select(userSelector);
  if (user.profiles.length > 0 && user.profiles[0].type === 'schoolCoach') {
    yield put(push(Routes.schoolAssignmentsBase));
  }
  return true;
}
